import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { ActionWithPayload } from "@obg/ngrx-utils";
import { AppError, MessageScopeType, MessageService, MessageType } from "@obg/ngx.core";
import { merge, of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";

import { LOYALTY_ACTION_TYPE, LoyaltyAction } from "./loyalty.action";
import { LoyaltyService } from "./loyalty.service";

@Injectable()
/**
 * @deprecated [fabric-deprecated] - use fabric LoyaltyService from app-account instead
 */
export class LoyaltyEffect {
	/**
	 * @deprecated [fabric-deprecated] - use "document.obgEventBus.retrieve(AccountAppValue.GetLoyaltyBalance)" instead
	 */
	getBalance$ = createEffect(() =>
		this.actions$.pipe(
			ofType(LOYALTY_ACTION_TYPE.getBalance),
			switchMap(() =>
				this.service.getBalance().pipe(
					map((response) => this.action.getBalanceSuccess(response)),
					catchError((response: AppError) => of(this.action.getBalanceFail(response)))
				)
			)
		)
	);
	/**
	 * @deprecated [fabric-deprecated] - use "document.obgEventBus.retrieve(AccountAppValue.GetLoyaltyLevel)" instead
	 */
	getBrandLoyaltyLevels$ = createEffect(() =>
		this.actions$.pipe(
			ofType(LOYALTY_ACTION_TYPE.getBrandLoyaltyLevels),
			switchMap(() =>
				this.service.getBrandLoyaltyLevels().pipe(
					map((response) => this.action.getBrandLoyaltyLevelsSuccess(response)),
					catchError((response: AppError) => of(this.action.getBrandLoyaltyLevelsFail(response)))
				)
			)
		)
	);
	/**
	 * @deprecated [fabric-deprecated] - use "document.obgEventBus.retrieve(AccountAppValue.GetLoyaltyHistory)" instead
	 */
	getHistory$ = createEffect(() =>
		this.actions$.pipe(
			ofType(LOYALTY_ACTION_TYPE.getHistory),
			switchMap((filter: ActionWithPayload) =>
				this.service.getHistory(filter.payload).pipe(
					map((response) => this.action.getHistorySuccess(response)),
					catchError((response: AppError) => of(this.action.getHistoryFail(response)))
				)
			)
		)
	);
	/**
	 * @deprecated [fabric-deprecated] - use "document.obgEventBus.retrieve(AccountAppValue.GetLoyaltyMonthlyHistory)" instead
	 */
	getMonthlyHistory$ = createEffect(() =>
		this.actions$.pipe(
			ofType(LOYALTY_ACTION_TYPE.getMonthlyHistory),
			switchMap(() =>
				this.service.getMonthlyHistory().pipe(
					map((response) => this.action.getMonthlyHistorySuccess(response)),
					catchError((response: AppError) => of(this.action.getMonthlyHistoryFail(response)))
				)
			)
		)
	);
	/**
	 * @deprecated [fabric-deprecated] - use "document.obgEventBus.dispatch(AccountAppCommand.GetLoyaltyExchangePoints)" instead
	 */
	exchangePoints$ = createEffect(() =>
		this.actions$.pipe(
			ofType(LOYALTY_ACTION_TYPE.exchangePoints),
			map((x: ActionWithPayload) => x.payload),
			switchMap((amount) =>
				this.service.exchangePoints(amount).pipe(
					map(() => this.action.exchangePointsSuccess(amount)),
					catchError((response: AppError) => of(this.action.exchangePointsFail(response)))
				)
			)
		)
	);

	initMessages$ = createEffect(() =>
		merge(
			this.messageService.map$({
				[LOYALTY_ACTION_TYPE.exchangePointsSuccess]: {
					context: LOYALTY_ACTION_TYPE.exchangePoints,
					scope: MessageScopeType.Local,
					type: MessageType.Success,
					messageCode: "",
				},
			}),
			this.messageService.mapErrorByContext$({
				[LOYALTY_ACTION_TYPE.exchangePointsFail]: LOYALTY_ACTION_TYPE.exchangePoints,
			}),
			this.messageService.mapClearByContext$({
				[LOYALTY_ACTION_TYPE.exchangePoints]: LOYALTY_ACTION_TYPE.exchangePoints,
			})
		)
	);

	constructor(
		private actions$: Actions,
		private messageService: MessageService,
		private action: LoyaltyAction,
		private service: LoyaltyService
	) {}
}
